import { selectorInfoProfile } from 'pages/Auth/slice/selector';
import { useSelector } from 'react-redux';
import { StorageServices } from '../utils/storage';

export const useCheckPermission = (
  requiredPermissions: string[] | undefined
): boolean => {
  const infoProfile = useSelector(selectorInfoProfile);
  const permission = StorageServices.getData('permission');

  if (
    infoProfile.is_supper ||
    !requiredPermissions ||
    !requiredPermissions.length
  ) {
    return true;
  }

  return requiredPermissions.every((perm) => permission.includes(perm));
};
